'use strict';
const angular = require('angular');

export default angular.module('appApp.furtherguidance', [])
  .directive('furtherguidance', function() {
    return {
      template: require('./furtherguidance.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/furtherguidance/furtherguidance.directive.js